import React from 'react'

import { motion } from 'framer-motion/dist/framer-motion'

export function Logo({ simple }) {
	let delay = 0.015

	return !simple ? (
		<motion.svg
			viewBox="0 0 611 167"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clip-path="url(#clip0_194_278)">
				<mask
					id="mask0_194_278"
					style={{ maskType: 'luminance' }}
					maskUnits="userSpaceOnUse"
					x="0"
					y="0"
					width="611"
					height="167"
				>
					<path d="M610.83 0H0V166.47H610.83V0Z" fill="white" />
				</mask>
				<g mask="url(#mask0_194_278)">
					<motion.path
						d="M590.27 166.47C601.625 166.47 610.83 157.265 610.83 145.91C610.83 134.555 601.625 125.35 590.27 125.35C578.915 125.35 569.71 134.555 569.71 145.91C569.71 157.265 578.915 166.47 590.27 166.47Z"
						fill="#3399FF"
						stroke="#189dfc"
						strokeWidth="0.5"
						initial={{ pathLength: 0, fill: '#189dfc00' }}
						animate={{ pathLength: 1, fill: '#189dfcFF' }}
						transition={{
							pathLength: { duration: 1 },
							fill: { delay, duration: 0.6 },
						}}
						strokeDasharray="1 10"
					/>
					<motion.path
						d="M128.63 166.3H0V0H43.8V123.97H109.91L128.64 166.3H128.63Z"
						fill="white"
						stroke="white"
						strokeWidth="0.5"
						initial={{ pathLength: 0, fill: '#FFFFFF00' }}
						animate={{ pathLength: 1, fill: '#FFFFFFFF' }}
						transition={{
							pathLength: { duration: 1 },
							fill: { delay: delay * 2, duration: 0.6 },
							delay,
						}}
						strokeDasharray="1 10"
					/>
					<motion.path
						d="M136.51 166.47C118.93 166.47 104.09 160.51 92.4101 148.74C80.7401 136.99 74.8201 121.97 74.8201 104.09C74.8201 86.21 80.7401 71 92.4201 59.32C104.1 47.64 118.94 41.71 136.51 41.71C154.08 41.71 168.92 47.63 180.6 59.32C192.28 71 198.2 86.06 198.2 104.09C198.2 122.12 192.28 136.98 180.6 148.74C168.92 160.5 154.08 166.47 136.5 166.47H136.51ZM136.51 78.96C130.34 78.96 125.23 81.09 120.9 85.49C116.55 89.89 114.44 95.98 114.44 104.1C114.44 112.22 116.55 118.31 120.9 122.71C125.23 127.1 130.33 129.24 136.51 129.24C142.69 129.24 147.79 127.1 152.12 122.71C156.47 118.31 158.58 112.22 158.58 104.1C158.58 95.98 156.47 89.89 152.12 85.49C147.79 81.1 142.68 78.96 136.51 78.96Z"
						fill="white"
						stroke="white"
						strokeWidth="0.5"
						initial={{ pathLength: 0, fill: '#FFFFFF00' }}
						animate={{ pathLength: 1, fill: '#FFFFFFFF' }}
						transition={{
							pathLength: { duration: 1 },
							fill: { delay: delay * 3, duration: 0.6 },
							delay: delay * 2,
						}}
						strokeDasharray="1 10"
					/>
					<motion.path
						d="M239.35 166.02C224.84 166.02 213.19 161.43 204.74 152.39C196.35 143.42 192.1 132.1 192.1 118.76V45.1001H232.97V108.85C232.97 114.8 234.41 119.37 237.38 122.8C240.5 126.41 242.1 127.68 247.77 127.68C253.44 127.68 255.63 126.19 258.89 122.78C262.09 119.44 263.65 115.03 263.65 109.3V45.1001H304.14V139.5C304.14 148.43 304.51 154.97 305.25 158.94L306.02 163.08H269.44L268.73 160.52C268.46 159.54 268.24 155.52 268.07 154.05C261.24 160.14 251.62 166.02 239.35 166.02Z"
						fill="white"
						stroke="white"
						strokeWidth="0.5"
						initial={{ pathLength: 0, fill: '#FFFFFF00' }}
						animate={{ pathLength: 1, fill: '#FFFFFFFF' }}
						transition={{
							pathLength: { duration: 1 },
							fill: { delay: delay * 4, duration: 0.6 },
							delay: delay * 3,
						}}
						strokeDasharray="1 10"
					/>
					<motion.path
						d="M351.02 163.09H310.4V45.0998H350.09V60.8699C354.34 52.6699 361.42 44.2 376.23 44.2C377.71 44.2 380.16 44.35 383.72 44.66L386.91 44.9398V85.5598L382.63 84.5898C380.25 84.0498 377.39 83.7799 374.14 83.7799C366.39 83.7799 362.89 85.7599 357.97 90.2099C353.46 94.2899 351.01 98.46 351.01 108.84V163.09H351.02Z"
						fill="white"
						stroke="white"
						strokeWidth="0.5"
						initial={{ pathLength: 0, fill: '#FFFFFF00' }}
						animate={{ pathLength: 1, fill: '#FFFFFFFF' }}
						transition={{
							pathLength: { duration: 1 },
							fill: { delay: delay * 6, duration: 0.6 },
							delay: delay * 5,
						}}
						strokeDasharray="1 10"
					/>
					<motion.path
						d="M457.52 120.86C453.73 129.53 446.65 133.75 435.93 133.75C429.14 133.75 423.47 131.67 418.61 127.4C415.25 124.44 413.5 118.94 412.81 113.48H487.97L491.36 113.42L491.47 110.03C491.47 109.84 491.51 109.35 491.57 108.56C491.65 107.56 491.72 108.34 491.81 106.86C491.89 105.32 491.93 103.98 491.93 102.73C491.93 83.83 486.65 68.78 476.22 58C465.77 47.19 451.21 41.71 432.96 41.71C417.16 41.71 403.27 47.55 391.69 59.08C380.1 70.61 374.22 85.6 374.22 103.63C374.22 122.59 380.27 137.98 392.19 149.36C404.07 160.7 418.71 166.46 435.7 166.46C449.48 166.46 461.35 162.89 470.98 155.86C479.73 149.47 485.82 141.36 489.2 131.76L457.51 120.85L457.52 120.86ZM419.27 78.01C423.11 74.15 426.33 72.38 432.72 72.38C439.77 72.38 444.55 74.14 447.96 77.63C450.42 80.16 452.69 83.83 453.26 90.19H413.67C414.3 84.43 416.59 80.7 419.27 78V78.01Z"
						fill="white"
						stroke="white"
						strokeWidth="0.5"
						initial={{ pathLength: 0, fill: '#FFFFFF00' }}
						animate={{ pathLength: 1, fill: '#FFFFFFFF' }}
						transition={{
							pathLength: { duration: 1 },
							fill: { delay: delay * 4, duration: 0.6 },
							delay: delay * 4,
						}}
						strokeDasharray="1 10"
					/>
					<motion.path
						d="M558.86 145.91C558.86 132.84 566.85 121.63 578.21 116.9C576.72 111.5 573.92 106.62 569.8 102.35C563.53 95.84 554.47 91.33 542.86 88.94L528.64 85.65C522.01 84.5 521.12 81.73 521.12 79.17C521.12 77.9 521.2 75.44 523.51 73.26C525.09 71.77 527.22 70.74 530.5 70.74C538.85 70.74 542.88 74.31 544.17 81.34L578.07 77.06L578.05 76.9C577.19 68.4 572.73 60.33 564.8 52.92C556.83 45.49 545.08 41.72 529.87 41.72C516.86 41.72 505.84 45.58 497.11 53.18C488.25 60.91 483.75 70.45 483.75 81.53C483.75 90.51 486.74 98.36 492.65 104.86C498.46 111.25 507.15 115.71 518.44 118.1L533.94 121.78C541.49 123.92 541.4 128.94 541.4 130.44C541.4 132.55 540.59 134.2 538.85 135.64C536.96 137.2 534.3 138 530.22 138C524.66 138 521.08 135.85 518.58 132.88C517.37 131.45 516.63 128.3 516.25 125.08L480.97 130.67C481.48 134.03 482.61 137.49 484.37 140.97C486.36 144.94 489.25 148.94 492.94 152.85C496.77 156.92 502.17 160.25 508.99 162.76C515.68 165.22 523.33 166.47 531.74 166.47C543.79 166.47 553.81 163.88 561.62 158.75C559.86 154.83 558.87 150.48 558.87 145.9L558.86 145.91Z"
						fill="white"
						stroke="white"
						strokeWidth="0.5"
						initial={{ pathLength: 0, fill: '#FFFFFF00' }}
						animate={{ pathLength: 1, fill: '#FFFFFFFF' }}
						transition={{
							pathLength: { duration: 1 },
							fill: { delay: delay * 4, duration: 0.6 },
							delay: delay * 4,
						}}
						strokeDasharray="1 10"
					/>
				</g>
			</g>
			<defs>
				<clipPath id="clip0_194_278">
					<rect width="611" height="167" fill="white" />
				</clipPath>
			</defs>
		</motion.svg>
	) : (
		// <motion.svg viewBox="0 0 158 41" fill="none">rokeDasharray="1 10"
		// 	/>
		// 	<motion.path
		// 		d="M117.74 32.1527C119.166 31.9208 120.564 31.7099 121.933 31.5168C123.301 31.3238 124.718 31.1114 126.185 30.8809C126.261 31.7293 126.599 32.4625 127.196 33.0789C127.793 33.6954 128.672 34.0051 129.829 34.0051C130.599 34.0051 131.217 33.8225 131.68 33.456C132.142 33.0909 132.374 32.6181 132.374 32.039C132.374 31.5767 132.2 31.1622 131.853 30.7956C131.506 30.4291 130.928 30.1508 130.119 29.9578L127.517 29.3787C124.239 28.647 121.887 27.48 120.461 25.8805C119.033 24.281 118.321 22.3823 118.321 20.1843C118.321 18.7584 118.629 17.4477 119.246 16.2522C119.862 15.0582 120.7 14.0258 121.761 13.158C122.821 12.2901 124.046 11.6168 125.434 11.1335C126.822 10.6518 128.268 10.4109 129.772 10.4109C131.738 10.4109 133.435 10.6712 134.861 11.1919C136.287 11.7126 137.472 12.3964 138.418 13.2447C139.362 14.0931 140.075 15.0283 140.558 16.0502C141.04 17.0721 141.339 18.0656 141.454 19.0277L133.068 20.1843C132.991 19.4526 132.702 18.8167 132.2 18.2766C131.699 17.738 130.928 17.4671 129.887 17.4671C129.347 17.4671 128.807 17.6212 128.268 17.9295C127.728 18.2377 127.458 18.7195 127.458 19.3748C127.458 20.4162 128.094 21.0521 129.368 21.2825L132.317 21.8616C135.672 22.5169 138.09 23.6646 139.575 25.3029C141.059 26.9413 141.802 28.8984 141.802 31.1727C141.802 32.4071 141.55 33.6116 141.049 34.7876C140.548 35.9637 139.795 37.014 138.794 37.9387C137.791 38.8634 136.548 39.607 135.063 40.1651C133.579 40.7232 131.853 41.003 129.887 41.003C127.573 41.003 125.655 40.6858 124.132 40.0484C122.608 39.4125 121.375 38.6315 120.429 37.7068C119.484 36.7821 118.81 35.8081 118.405 34.7861C118.001 33.7657 117.778 32.8874 117.74 32.1542V32.1527Z"
		// 		fill="transparent"
		// 		stroke="white"
		// 		strokeWidth="0.5"
		// 		initial={{ pathLength: 0, fill: '#FFFFFF00' }}
		// 		animate={{ pathLength: 1, fill: '#FFFFFFFF' }}
		// 		transition={{
		// 			pathLength: { duration: 1 },
		// 			fill: { delay: delay * 4, duration: 0.6 },
		// 			delay: delay * 4,
		// 		}}
		// 		strokeDasharray="1 10"
		// 	/>
		// </motion.svg>
		<svg
			width="611"
			height="167"
			viewBox="0 0 611 167"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_194_278)">
				<mask
					id="mask0_194_278"
					style={{ maskType: 'luminance' }}
					maskUnits="userSpaceOnUse"
					x="0"
					y="0"
					width="611"
					height="167"
				>
					<path d="M610.83 0H0V166.47H610.83V0Z" fill="white" />
				</mask>
				<g mask="url(#mask0_194_278)">
					<path
						d="M590.27 166.47C601.625 166.47 610.83 157.265 610.83 145.91C610.83 134.555 601.625 125.35 590.27 125.35C578.915 125.35 569.71 134.555 569.71 145.91C569.71 157.265 578.915 166.47 590.27 166.47Z"
						fill="#3399FF"
					/>
					<path
						d="M128.63 166.3H0V0H43.8V123.97H109.91L128.64 166.3H128.63Z"
						fill="white"
					/>
					<path
						d="M136.51 166.47C118.93 166.47 104.09 160.51 92.4101 148.74C80.7401 136.99 74.8201 121.97 74.8201 104.09C74.8201 86.21 80.7401 71 92.4201 59.32C104.1 47.64 118.94 41.71 136.51 41.71C154.08 41.71 168.92 47.63 180.6 59.32C192.28 71 198.2 86.06 198.2 104.09C198.2 122.12 192.28 136.98 180.6 148.74C168.92 160.5 154.08 166.47 136.5 166.47H136.51ZM136.51 78.96C130.34 78.96 125.23 81.09 120.9 85.49C116.55 89.89 114.44 95.98 114.44 104.1C114.44 112.22 116.55 118.31 120.9 122.71C125.23 127.1 130.33 129.24 136.51 129.24C142.69 129.24 147.79 127.1 152.12 122.71C156.47 118.31 158.58 112.22 158.58 104.1C158.58 95.98 156.47 89.89 152.12 85.49C147.79 81.1 142.68 78.96 136.51 78.96Z"
						fill="white"
					/>
					<path
						d="M239.35 166.02C224.84 166.02 213.19 161.43 204.74 152.39C196.35 143.42 192.1 132.1 192.1 118.76V45.1001H232.97V108.85C232.97 114.8 234.41 119.37 237.38 122.8C240.5 126.41 242.1 127.68 247.77 127.68C253.44 127.68 255.63 126.19 258.89 122.78C262.09 119.44 263.65 115.03 263.65 109.3V45.1001H304.14V139.5C304.14 148.43 304.51 154.97 305.25 158.94L306.02 163.08H269.44L268.73 160.52C268.46 159.54 268.24 155.52 268.07 154.05C261.24 160.14 251.62 166.02 239.35 166.02Z"
						fill="white"
					/>
					<path
						d="M351.02 163.09H310.4V45.0998H350.09V60.8699C354.34 52.6699 361.42 44.2 376.23 44.2C377.71 44.2 380.16 44.35 383.72 44.66L386.91 44.9398V85.5598L382.63 84.5898C380.25 84.0498 377.39 83.7799 374.14 83.7799C366.39 83.7799 362.89 85.7599 357.97 90.2099C353.46 94.2899 351.01 98.46 351.01 108.84V163.09H351.02Z"
						fill="white"
					/>
					<path
						d="M457.52 120.86C453.73 129.53 446.65 133.75 435.93 133.75C429.14 133.75 423.47 131.67 418.61 127.4C415.25 124.44 413.5 118.94 412.81 113.48H487.97L491.36 113.42L491.47 110.03C491.47 109.84 491.51 109.35 491.57 108.56C491.65 107.56 491.72 108.34 491.81 106.86C491.89 105.32 491.93 103.98 491.93 102.73C491.93 83.83 486.65 68.78 476.22 58C465.77 47.19 451.21 41.71 432.96 41.71C417.16 41.71 403.27 47.55 391.69 59.08C380.1 70.61 374.22 85.6 374.22 103.63C374.22 122.59 380.27 137.98 392.19 149.36C404.07 160.7 418.71 166.46 435.7 166.46C449.48 166.46 461.35 162.89 470.98 155.86C479.73 149.47 485.82 141.36 489.2 131.76L457.51 120.85L457.52 120.86ZM419.27 78.01C423.11 74.15 426.33 72.38 432.72 72.38C439.77 72.38 444.55 74.14 447.96 77.63C450.42 80.16 452.69 83.83 453.26 90.19H413.67C414.3 84.43 416.59 80.7 419.27 78V78.01Z"
						fill="white"
					/>
					<path
						d="M558.86 145.91C558.86 132.84 566.85 121.63 578.21 116.9C576.72 111.5 573.92 106.62 569.8 102.35C563.53 95.84 554.47 91.33 542.86 88.94L528.64 85.65C522.01 84.5 521.12 81.73 521.12 79.17C521.12 77.9 521.2 75.44 523.51 73.26C525.09 71.77 527.22 70.74 530.5 70.74C538.85 70.74 542.88 74.31 544.17 81.34L578.07 77.06L578.05 76.9C577.19 68.4 572.73 60.33 564.8 52.92C556.83 45.49 545.08 41.72 529.87 41.72C516.86 41.72 505.84 45.58 497.11 53.18C488.25 60.91 483.75 70.45 483.75 81.53C483.75 90.51 486.74 98.36 492.65 104.86C498.46 111.25 507.15 115.71 518.44 118.1L533.94 121.78C541.49 123.92 541.4 128.94 541.4 130.44C541.4 132.55 540.59 134.2 538.85 135.64C536.96 137.2 534.3 138 530.22 138C524.66 138 521.08 135.85 518.58 132.88C517.37 131.45 516.63 128.3 516.25 125.08L480.97 130.67C481.48 134.03 482.61 137.49 484.37 140.97C486.36 144.94 489.25 148.94 492.94 152.85C496.77 156.92 502.17 160.25 508.99 162.76C515.68 165.22 523.33 166.47 531.74 166.47C543.79 166.47 553.81 163.88 561.62 158.75C559.86 154.83 558.87 150.48 558.87 145.9L558.86 145.91Z"
						fill="white"
					/>
				</g>
			</g>
			<defs>
				<clipPath id="clip0_194_278">
					<rect width="611" height="167" fill="white" />
				</clipPath>
			</defs>
		</svg>
	)
}
